import { IssueTaskCategory, IssueTaskDoc, IssueTaskStatus } from '@gooduncles/gu-app-schema';
import { FC } from 'react';
import { formatNumber } from 'src/utils/common';
import { costIssueTaskCategories } from 'src/utils/constants/business-constants';

import classes from './IssueTaskItem.module.scss';

type IssueTaskItemProps = {
  issueTask: IssueTaskDoc;
};

const issueTaskCategoryMap: Record<IssueTaskCategory, string> = {
  [IssueTaskCategory.PICK_UP]: '회수',
  [IssueTaskCategory.DELIVERY]: '이슈배송',
  [IssueTaskCategory.QUICK]: '퀵',
  [IssueTaskCategory.REFUND]: '환불',
  [IssueTaskCategory.ADDITIONAL_CHARGE]: '추가청구',
  [IssueTaskCategory.OTHER]: '기타',
  [IssueTaskCategory.INTERNAL]: '내부처리',
  [IssueTaskCategory.REQUEST]: '요청 응대',
};

const issueTaskStatusMap: Record<IssueTaskStatus, string> = {
  [IssueTaskStatus.PENDING]: '대기',
  [IssueTaskStatus.OPEN]: '등록완료',
  [IssueTaskStatus.IN_PROGRESS]: '진행중',
  [IssueTaskStatus.FAILED]: '실패',
  [IssueTaskStatus.COMPLETED]: '완료',
  [IssueTaskStatus.CANCELED]: '취소',
  [IssueTaskStatus.DELETED]: '삭제',
};

const IssueTaskItem: FC<IssueTaskItemProps> = ({ issueTask }) => {
  const shouldShowAmount = costIssueTaskCategories.includes(issueTask.category);
  const categoryText = issueTaskCategoryMap[issueTask.category];
  const statusText = issueTaskStatusMap[issueTask.status];
  const totalAmount = issueTask.amount?.totalAmount ?? null;

  return (
    <div className={classes.issueTaskItem}>
      <div className={classes.header}>
        <span className={classes.category}>{categoryText}</span>
        <span className={classes.status}>{statusText}</span>
      </div>

      {issueTask.publicNote && <p className={classes.memo}>{issueTask.publicNote}</p>}

      {issueTask.products && issueTask.products.length > 0 && (
        <div className={classes.products}>
          {issueTask.products.map((product) => (
            <div key={product.productId} className={classes.productItem}>
              <span className={classes.productName}>{product.productName}</span>
              <span className={classes.productVolume}>
                {product.quantity ? `x ${formatNumber(product.quantity)}` : ''}
              </span>
            </div>
          ))}
        </div>
      )}

      {totalAmount !== null && shouldShowAmount && (
        <div className={classes.amountInfo}>
          <span>금액</span>
          <span>{formatNumber(totalAmount)}원</span>
        </div>
      )}
    </div>
  );
};

export default IssueTaskItem;
